// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"dba2c56515bb3073df8a","655":"d00d00496dbd15952150"}[chunkId] + ".js";
};